import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { Alert } from '@mui/material';

export class FormUserDetails extends Component {

	constructor(props) {
		super(props);
		this.state = { msg: '', isLoggedin: null, isRegistered: null };
	}

	register = e => {
		e.preventDefault();
		this.sendRegisterRequest()
	}

	login = e => {
		e.preventDefault();
		this.sendLoginRequest();
	}

	async sendLoginRequest() {

		const { values: { username, password } } = this.props;
		console.log('username: ' + username);
		console.log('username: ' + password);

		let url = 'http://ec2-13-245-163-37.af-south-1.compute.amazonaws.com:8081/api/coindispenser/login'
		let response;
		let body;

		try {
			response = await fetch(url, {
				method: 'GET',
				headers: {
					'Authorization': 'Basic ' + btoa(`${username}:${password}`)
				},
				mode: 'cors',
			});


			body = await response.json();
		} catch (error) {
			console.log(error);
		}

		console.log(response)
		console.log(response.ok)
		console.log(body);

		if (response.ok) {
			//go to the main page
			this.setState({ msg: "Success", isLoggedin: true })
			this.props.nextStep();
		}
		else {
			this.setState({isLoggedin: false, isRegistered: null })
		}
	}

	async sendRegisterRequest() {

		const { values: { username, password } } = this.props;
		console.log('username: ' + username);
		console.log('username: ' + password);

		console.log(`${username}:${password}`);



		let baseUrl = 'http://ec2-13-245-163-37.af-south-1.compute.amazonaws.com:8081/'
		let url = 'api/coindispenser/createuser';
		url = baseUrl + url

		let response;
		let body;

		try {
			response = await fetch(url, {
				method: 'POST',
				headers: {
					'Authorization': 'Basic ' + btoa('kk:pass'),
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ username: `${username}`, password: `${password}`}),
				mode: 'cors',
			});


			body = await response.json();
		} catch (error) {
			console.log(error);
		}

		console.log(response)
		console.log(response.ok)
		console.log(body);

		if (response.ok) {
			//go to the main page
			this.setState({ isLoggedin: null, isRegistered: true })
		}
		else {
			this.setState({ isLoggedin: null, isRegistered: false })
		}
	}

	render() {

		const { values, handleChange } = this.props;
		const { values: { msg, isLoggedin, isRegistered } } = this.props;

		let loginAlert;
		let registerAlert;

		console.log("isloggged: " + isLoggedin);

		if (this.state.isLoggedin == null) {

			loginAlert = null;
		}
		else if (this.state.isLoggedin == false) {
			loginAlert = <Alert severity="warning">Incorrect username/password!</Alert>
		}
		else if (this.state.isLoggedin == true) {
			loginAlert = <Alert severity="success">Logged in</Alert>
		}

		if (this.state.isRegistered == null) {

			registerAlert = null;
		}
		else if (this.state.isRegistered == false) {
			registerAlert = <Alert severity="warning">Could not be registered try again!</Alert>
		}
		else if (this.state.isRegistered == true) {
			registerAlert = <Alert severity="success">Registered, you may proceed to login</Alert>
		}


		return(
			<MuiThemeProvider>
				<React.Fragment>
					<AppBar title="Login/Register" />
					<TextField
						hintText="Enter a username"
						floatingLabelText="Username"
						onChange={handleChange('username')}
						defaultValue={values.username}
					/>

					<br />
					<TextField
						hintText="Enter Password"
						floatingLabelText="Password"
						onChange={handleChange('password')}
						defaultValue={values.password}
					/>

					<br />
					<RaisedButton
						label="register"
						primary={true}
						style={styles.button}
						onClick={this.register}
					/>

					<RaisedButton
						label="login"
						primary={false}
						style={styles.button}
						onClick={this.login}
					/>

					<h1>{this.state.msg}</h1>
					{loginAlert}
					{registerAlert}

				</React.Fragment>
			</MuiThemeProvider>
		)
	}
}

const styles = {
	margin:100
}
export default FormUserDetails;